import React from 'react'
import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'

function StyleButton({
  isActive, label, onToggle, style,
}) {
  function onBtnToggle(e) {
    e.preventDefault()
    onToggle(style)
  }

  return (
    <span
      className={`rich-editor__style-button ${isActive ? 'is-active' : ''}`}
      onMouseDown={onBtnToggle}
    >
      <Icon type={['fas', label]} />
    </span>
  )
}

StyleButton.propTypes = {
  isActive: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  onToggle: PropTypes.func.isRequired,
  style: PropTypes.string.isRequired,
}

export default StyleButton
